import { render } from "./leftmenu-layout.vue?vue&type=template&id=e3ca31f0&ts=true"
import script from "./leftmenu-layout.vue?vue&type=script&lang=ts"
export * from "./leftmenu-layout.vue?vue&type=script&lang=ts"

import "./leftmenu-layout.vue?vue&type=style&index=0&id=e3ca31f0&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__